import React from 'react';
import classNames from 'classnames';
import { EMPTY_SPACE } from 'twain-sport-fe-mono/constants/textSymbols';
import { IParticipantBannerDetails } from 'twain-sport-fe-mono/interfaces/IParticipant';
import { translationProvider } from 'twain-sport-fe-mono/store/translations';
import classes from './ParticipantBanner.module.scss';

interface IProps {
    participant: IParticipantBannerDetails;
    picture: string;
    className?: string;
}

export const ParticipantBanner: React.FC<React.PropsWithChildren<IProps>> = (props) => (
    <div className={classNames(classes.container, props.className)}>
        <img
            src={props.picture}
            className={classes.avatar}
            alt={props.participant.nickname}
            data-qa="image-profile-avatar"
        />
        <div className={classes.filter} />
        <div className={classes.info}>
            <div className={classes.nameSection}>
                <h3>#{props.participant.jerseyNumber}</h3>
                <h2>{props.participant.nickname}</h2>
                <div className={classes.rank}>
                    {!!props.participant.rank && (
                        <>
                            {translationProvider.string('rank')}:{EMPTY_SPACE}
                            {props.participant.rank}
                        </>
                    )}
                </div>
            </div>
            {props.children}
        </div>
    </div>
);
